<!--
  @author:sunluhua
  @time:2020/9/14
  @disc:销售计划导出3
 -->
<template>
  <div class="sale-query">
    <div style="overflow:hidden;padding: 20px">
      <el-button type="primary" @click="tap('当前为SAP差异流水对账')">SAP差异流水对账</el-button>
      <el-button type="primary" @click="tap('当前为电商差异流水对账')">电商差异流水对账</el-button>
    </div>
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="100px">
      <el-form-item label="单据号" prop="ces5">
        <el-input v-model="form.ces5" placeholder="请输入单据编号"></el-input>
      </el-form-item>
      <el-form-item label="是否有差异" prop="ces6">
        <el-select v-model="form.ces6" placeholder="请选择">
          <el-option
            v-for="item in ces6"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务类型" prop="ces7">
        <el-select v-model="form.ces7" placeholder="请选择">
          <el-option
            v-for="item in ces7"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="ces1">
        <el-input v-model="form.ces1" placeholder="请输入单据编号"></el-input>
      </el-form-item>
      <el-form-item label="经营组织" prop="ces4">
        <el-select v-model="form.ces4" placeholder="请选择">
          <el-option
            v-for="item in saleType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="币种" prop="ces3">
        <el-select v-model="form.ces3" multiple placeholder="请选择">
          <el-option
            v-for="item in moneyType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="日期" prop="tareWeightTime">
        <el-date-picker
          v-model="form.tareWeightTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light"
      ref="multipleTable">
      <el-table-column
        prop="deptName"
        label="单据编号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="orderNum"
        label="是否差异"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="takeOrderNo"
        label="业务类型"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="code"
        label="币种"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="支付方式"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="经营组织"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="电商交易时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="电商流水号"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="itemName"
        label="增款协议编号"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="SAP凭证日期"
        label="创建时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="SAP凭证号"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="itemName"
        label="SAP单据创建时间"
        show-overflow-tooltip>
      </el-table-column> -->
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
    <el-row class="export-row" type="flex" justify="end" v-permission="'0071208'">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.size">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.page">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button type="primary">导出为CSV文件</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { formatTime } from '../../../common/utils'
import AjaxSelect from '../../../components/ajaxSelect/index'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'

export default {
  name: 'saleQuery',
  components: { AjaxSelect, MultiCascader },
  data () {
    return {
      form: {
        tareWeightTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)]
      },
      addData: {},
      ces6: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ],
      ces7: [
        { value: 1, label: '单据号1' },
        { value: 2, label: '单据号2' }
      ],
      moneyType: [
        { value: 1, label: 'CNY' },
        { value: 2, label: 'USD' },
        { value: 3, label: 'EUR' }
      ],
      saleType: [
        { value: 1, label: '全部' },
        { value: 2, label: '经营组织1' },
        { value: 3, label: '经营组织2' }
      ],
      list: [],
      citisOptions: [],
      total: 0,
      listState: {
        pageSize: 10,
        pageNo: 1
      },
      addModalVisible: false,
      exportForm: {
        size: 1000,
        page: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ]
    }
  },
  methods: {
    tap (e) {
      this.$message.success(e)
    },
    // 搜索
    handleSearch () {
      console.log('jashjdhashdk')
      // const params = {
      //   ...this.listState
      // }
      // this.getCombineOrderInfo(params).then(res => {
      //   const { list, total, pageNo, pageSize } = res.data
      //   this.tableData = list
      //   this.listState.total = total
      //   this.listState.pageNo = pageNo
      //   this.listState.pageSize = pageSize
      // })
    },
    // 分页条数变更
    handleSizeChange (val) {
      console.log(val)
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.listState.pageNo = val
      this.handleSearch()
    },
    resetAccount () {
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      this.handleSearch()
    }
  },
  mounted () {
    this.isCheckRecord = ''
    this.form.orderTime = ''
    this.handleSearch()
  }
}
</script>

<style scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
